import { observable } from 'mobx'
import Api from '@api/groupMember'
import { message } from 'hljd'

class Store {
  @observable visible = false
  @observable inputSearch = ''
  @observable list = []

  setStoreData = params => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })
  }

  openModal = () => {
    this.visible = true
  }
  // todo 虚拟滚动
  getList = async (params = {}) => {
    const {
      data: { list },
      success
    } = await Api.memberList({
      name: this.inputSearch,
      perPage: 100,
      ...params
    })
    if (success) {
      this.list = list || []

      if (this.list.length == 0) {
        message.warn('未搜索到成员')
      }
    }
  }

  onApply = async id => {
    const { success } = await Api.inviteMember({ merchantId: id })
    if (success) {
      this.getList()
    }
  }
}

export default Store
